import { RunTimeLayoutConfig } from '@umijs/max';
import { message } from 'antd';
import { App as AntApp } from 'antd';
import { RequestConfig } from '@umijs/max';
import { errorConfig } from './requestErrorConfig';
import RightContent from '@/components/RightContent';
import Footer from '@/components/Footer';
import defaultSettings from '@/../config/defaultSettings';
import { authService } from '@/services/authService';
import { history, Link } from '@umijs/max';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import { getLocale } from '@umijs/max';
import { MenuDataItem } from '@ant-design/pro-components';

const isDev = process.env.NODE_ENV === 'development';
const loginPath = '/login';

// 获取当前语言对应的 Ant Design 语言包
const getAntdLocale = () => {
  const locale = getLocale();
  return locale === 'zh-CN' ? zhCN : enUS;
};

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  currentUser?: API.CurrentUser;
  loading?: boolean;
}> {
  try {
    const currentUser = await authService.getCurrentUser();
    return {
      currentUser: currentUser || undefined,
    };
  } catch (error) {
    console.error('Failed to get initial state:', error);
    return {};
  }
}

// @ts-ignore
export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  return {
    rightContentRender: () => <RightContent />,
    footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 公开路径列表（不需要登录）
      const publicPaths = [loginPath, '/register', '/member-welcome'];
      // If not logged in and not on a public path, redirect to login
      if (!initialState?.currentUser && !publicPaths.includes(location.pathname)) {
        history.push(loginPath);
      }
    },
    menuItemRender: (item, dom) => {
      if (item.isUrl || !item.path) {
        return dom;
      }

      return (
        <Link
          className={item.path === '/headquarters' ? 'sidebar-bottom-menu-start' : undefined}
          to={item.path}
        >
          {dom}
        </Link>
      );
    },
    subMenuItemRender: (item, dom) =>
      item.path === '/headquarters' ? (
        <span className="sidebar-bottom-menu-start">{dom}</span>
      ) : (
        dom
      ),
    ...defaultSettings,
  };
};

export function rootContainer(container: any) {
  return (
    <ConfigProvider locale={getAntdLocale()}>
      <AntApp>
        {container}
      </AntApp>
    </ConfigProvider>
  );
}

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
  ...errorConfig,
};
